"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedPresetsWidgetContextProvider = exports.EmbedPresetsWidgetContextConsumer = exports.useEmbedPresetsWidgetContext = exports.EmbedPresetsWidgetContext = exports.EmbedStep = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var widgetEventHelperFunctions_1 = require("./widgetEventHelperFunctions");
var EmbedPresetOptions_1 = require("./EmbedPresetOptions");
var EmbedStep;
(function (EmbedStep) {
    EmbedStep["ChooseSource"] = "choose source";
    EmbedStep["EnterEmbedCode"] = "enter embed code";
})(EmbedStep = exports.EmbedStep || (exports.EmbedStep = {}));
exports.EmbedPresetsWidgetContext = react_1.default.createContext(undefined);
var useEmbedPresetsWidgetContext = function () {
    var context = react_1.default.useContext(exports.EmbedPresetsWidgetContext);
    if (!context) {
        throw new Error("useEmbedPresetsStepState() must be used within a <EmbedPresetsWidgetStepStateContext.Provider> component");
    }
    return context;
};
exports.useEmbedPresetsWidgetContext = useEmbedPresetsWidgetContext;
exports.EmbedPresetsWidgetContextConsumer = (0, mobx_react_1.observer)(function (_a) {
    var children = _a.children;
    var context = (0, react_1.useContext)(exports.EmbedPresetsWidgetContext);
    if (!context) {
        throw new Error("useEmbedPresetsStepState() must be used within a <EmbedPresetsWidgetStepStateContext.Provider> component");
    }
    return children(context);
});
var EmbedPresetsWidgetContextProvider = function (_a) {
    var children = _a.children, widgetManager = _a.widgetManager, telemetry = _a.telemetry, element = _a.element, embedUrl = _a.embedUrl, embedPreset = _a.embedPreset, isUsingWidget = _a.isUsingWidget, variable = _a.variable;
    var initialStep = EmbedStep.ChooseSource;
    if (embedUrl) {
        initialStep = EmbedStep.EnterEmbedCode;
    }
    var _b = __read(react_1.default.useState(initialStep), 2), currentStep = _b[0], setCurrentStep = _b[1];
    var savedPreset = (0, EmbedPresetOptions_1.getEmbedPresetByKey)(embedPreset);
    var _c = __read(react_1.default.useState(savedPreset), 2), preset = _c[0], setPreset = _c[1];
    var _d = __read(react_1.default.useState(false), 2), showPresetsOverlay = _d[0], setShowPresetsOverlay = _d[1];
    var _e = __read(react_1.default.useState(variable ? "token" : "url"), 2), mode = _e[0], setMode = _e[1];
    react_1.default.useEffect(function () {
        if (showPresetsOverlay && !isUsingWidget) {
            setShowPresetsOverlay(false);
        }
    }, [setShowPresetsOverlay, isUsingWidget, showPresetsOverlay]);
    var handleDisplayUrlChangeFunc = function (embedUrl, preset) {
        return (0, widgetEventHelperFunctions_1.handleDisplayUrlChange)({ embedUrl: embedUrl, widgetManager: widgetManager, telemetry: telemetry, element: element, preset: preset });
    };
    return (react_1.default.createElement(exports.EmbedPresetsWidgetContext.Provider, { value: {
            currentStep: currentStep,
            setStep: setCurrentStep,
            handleDisplayUrlChange: handleDisplayUrlChangeFunc,
            selectedPreset: preset,
            setPreset: setPreset,
            showPresetsOverlay: showPresetsOverlay,
            setShowPresetsOverlay: setShowPresetsOverlay,
            mode: mode,
            setMode: setMode,
        } }, children));
};
exports.EmbedPresetsWidgetContextProvider = EmbedPresetsWidgetContextProvider;
